






















































































































































































import { Vue, Component, Prop, PropSync, Model, Watch} from 'vue-property-decorator';
import { IPeriodPickerPresets, IPeriodPicker } from '@/types';
import { Chips } from '@/components/Chips';

@Component({
  name: 'PeriodPicker',
  components: { Chips },
})
export default class PeriodPicker extends Vue {
  private static stringWithPeriod(str, period) {
    return str.replace('%(months)',
        `${period}`);
  }
  @Prop({type: Object, default: () => {}}) public readonly translation!: IPeriodPicker['translation'];
  @Prop({type: Object, required: true}) public readonly limits!: IPeriodPicker['limits'];
  @Prop({type: String}) public readonly startDate!: string | null;
  @Prop({type: Boolean}) public readonly mobile!: boolean;
  @Prop({type: Boolean, default: false}) public readonly readonly!: boolean;
  @Prop({type: Array}) public readonly presets!: IPeriodPicker['presets'];
  @PropSync('endDate', {type: String}) public syncedEndDate!: string;

  @Model('change', { type: Number }) public readonly value!: number;

  private activeChips: number | null = null;
  private clickedOnPage: ((e: any) => void) | null = null;
  private countersButtonBlock: boolean = true;
  private showPeriodErrorBlock: boolean = false;
  private showCountersBlock: boolean | null = null;
  private actualErrorText: string = 'Wrong period';

  public get disabledMonthDecrease() {
    return this.value <= this.limits.min || !!(this.value < 1);
  }

  public get disabledMonthIncrease() {
    return this.value >= this.limits.max;
  }

  public get disabledYearDecrease() {
    return this.value <= this.limits.min || this.year < 1;
  }

  public get disabledYearIncrease() {
    return this.year > (this.limits.max / 12 - 1);
  }

  public get month() {
    if (!(this.value < 0)) {
      return this.value % 12;
    }
  }

  public get maxLimit() {
    return '';
  }

  public get year() {
    return Math.floor(this.value / 12);
  }

  @Watch('startDate', { immediate: true })
  private reCalculateEnd() {
    this.calculateEnd(this.value);
  }

  private toggleCounterBlock() {
    if (this.readonly) { return; }
    this.showCountersBlock = !this.showCountersBlock;
    this.showPeriodErrorBlock = false;
  }

  private calculateEnd(months) {
    if (this.startDate) {
      const end = this.$dayjs(this.startDate).add(months, 'month').format('YYYY-MM-DD');
      this.syncedEndDate = end;
      return this.syncedEndDate;
    }
  }

  private decrease() {
    if (this.disabledMonthDecrease) {
      this.showPeriodError('min');
    } else {
      const period = this.value - 1;
      this.showPeriodErrorBlock = false;
      this.calculateEnd(period);
      this.$emit('change', period);
    }
  }

  private increase() {
    if (this.value >= this.limits.max) {
      this.showPeriodError('max');
    } else {
      const period = this.value + 1;
      this.showPeriodErrorBlock = false;
      this.calculateEnd(period);
      this.$emit('change', period);
    }
  }

  private decreaseYear() {
    if (this.disabledYearDecrease) {
      this.showPeriodError('min');
    } else {
      let period = this.value - 12;
      if (period < this.limits.min) {
        period = this.limits.min;
      }
      this.showPeriodErrorBlock = false;
      this.calculateEnd(period);
      this.$emit('change', period);
    }
  }

  private increaseYear() {
    if (this.year >= (this.limits.max / 12 - 1)) {
      this.showPeriodError('max');
    } else {
      let period = this.value + 12 - (this.value % 12);
      if (period >= this.limits.max) {
        period = this.limits.max;
        this.calculateEnd(period);
      }
      this.showPeriodErrorBlock = false;
      this.calculateEnd(period);
      this.$emit('change', period);
    }
  }

  private setValue(value) {
    this.calculateEnd(value);
    this.showPeriodErrorBlock = false;
    this.$emit('change', value);
    this.showCountersBlock = !this.showCountersBlock;
  }

  private created() {
    this.calculateEnd(this.value);
    this.clickedOnPage = (e) => {
      if (this.showCountersBlock
        && e.target.id !== 'period-description'
        && e.target.parentElement.id !== 'period-description'
        && !e.target.closest('.periodPickerMob')
        && !this.$el.contains(e.target)) {
        this.showCountersBlock = !this.showCountersBlock;
      }
    };
    document.addEventListener('click', this.clickedOnPage);
  }

  private destroyed() {
    if (this.clickedOnPage) {
      document.removeEventListener('click', this.clickedOnPage);
    }
  }

  private showPeriodError(type) {
    if (this.translation.error_max && this.translation.error_min) {
      this.actualErrorText = type === 'max'
                              ? PeriodPicker.stringWithPeriod(this.translation.error_max, this.limits.max)
                              : PeriodPicker.stringWithPeriod(this.translation.error_min, this.limits.min);
    }
    this.showPeriodErrorBlock = true;
  }
}
